import { render, staticRenderFns } from "./items-types.vue?vue&type=template&id=33a5dbbc"
import script from "./items-types.vue?vue&type=script&lang=js"
export * from "./items-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports